export const NoteType = {
  MILESTONE: 'milestone',
  MILESTONE_EDIT_HISTORY: 'milestone_edit_history',
  CONTRACT: 'contract',
  INVOICE: 'invoice',
  HIGH_RISK: 'high_risk',
  WITHOUTPO: 'without_po',
  OPPORTUNITY_STATUS: 'opportunity_status',
};
